import clsx from 'clsx';
import React from 'react';
import { Box } from '../Box';
import { Text } from '../Text';
export function ActionListGroup(props) {
    const { children, label, elementType = 'ul', className, ...rest } = props;
    return (React.createElement(Box.Restricted, { ...rest, elementType: elementType, role: "group", className: clsx('mollie-ui-action-list-group', className) },
        label && (React.createElement(Text, { elementType: "div", className: "mollie-ui-action-list-group-label", variant: "caption-semi-bold", color: "secondary" }, label)),
        children));
}
ActionListGroup.displayName = 'ActionList.Group';
//# sourceMappingURL=ActionListGroup.js.map